import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56d71f0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "requirements" }

import { ref } from 'vue'

import { Password } from '@/popup/components/shared/Form/Form'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { t } from '@/popup/lib/i18n'
import { RequirementsMap } from '@/popup/components/shared/Form/FormTypes'
import { highEntropyPasswordValidator } from '@/popup/components/shared/Form/validators'

type Props = {
  autofocus: boolean
}

type Emits = {
  (event: 'update-password', value: string, isPassed: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePassword',
  props: {
    autofocus: { type: Boolean, default: false }
  },
  emits: ["update-password"],
  setup(__props: any, { emit: __emit }) {

const info: { message: string; key: keyof RequirementsMap }[] = [
  { message: t('create_new_account.upper_case'), key: 'upperCase' },
  { message: t('create_new_account.one_number'), key: 'oneNumber' },
  {
    message: t('create_new_account.special_character'),
    key: 'specialCharacter',
  },
  { message: t('create_new_account.no_space'), key: 'noSpace' },
  {
    message: t('create_new_account.eight_characters'),
    key: 'eightCharacters',
  },
]



const emits = __emit

const password = ref('')
const isPassed = ref(false)
const requirementsMap = ref<RequirementsMap>({
  upperCase: false,
  oneNumber: false,
  specialCharacter: false,
  noSpace: false,
  eightCharacters: false,
  lowerCase: false,
})

const onPasswordChange = async () => {
  const { requirements, passed } = highEntropyPasswordValidator(password.value)
  requirementsMap.value = requirements
  isPassed.value = passed
  emits('update-password', password.value, isPassed.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Password), {
      password: password.value,
      "onUpdate:password": [
        _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        onPasswordChange
      ],
      "hide-errors": "",
      autofocus: _ctx.autofocus,
      autocomplete: "new-password",
      class: "mb-4"
    }, null, 8 /* PROPS */, ["password", "autofocus"]),
    _createElementVNode("div", {
      class: _normalizeClass([password.value ? 'show' : '', "wrapper"])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(info, ({ message, key }) => {
        return _createElementVNode("div", {
          class: "mb-1",
          key: key
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (requirementsMap.value[key])
                  ? (_openBlock(), _createBlock(SvgIcon, {
                      key: 0,
                      class: "mr-2",
                      color: "var(--green-54)",
                      "data-testid": `${key}-complete`,
                      name: "complete",
                      height: "16",
                      width: "16"
                    }, null, 8 /* PROPS */, ["data-testid"]))
                  : (_openBlock(), _createBlock(SvgIcon, {
                      key: 1,
                      class: "mr-2",
                      "secondary-color": "var(--neutral-100)",
                      color: "var(--neutral-75)",
                      "data-testid": `${key}-fail`,
                      name: "cross-outline",
                      height: "16",
                      width: "16"
                    }, null, 8 /* PROPS */, ["data-testid"]))
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createElementVNode("p", {
              class: _normalizeClass(requirementsMap.value[key] ? '' : 'grey')
            }, _toDisplayString(message), 3 /* TEXT, CLASS */)
          ])
        ])
      }), 64 /* STABLE_FRAGMENT */))
    ], 2 /* CLASS */)
  ]))
}
}

})